import { CSSProperties, useRef } from 'react';
import { PlacesType, Tooltip, TooltipRefProps } from 'react-tooltip';
import { useUserStore } from '../../../../../modules/Auth/stores/authStore';
import { Button } from '../../../../components/atoms/Button';
import { Chip } from '../../../../components/atoms/Chip';
import { showChipAprovaLive } from '../../../../utils/aprovaLive';

interface MenuDropDownProps {
  menu: any;
  setActive: (url: string) => 'selected' | 'focusable';
  id: string;
  offset?: number;
  position: PlacesType;
  arrow?: boolean;
  onClick?: boolean;
  afterHide?: (status: boolean) => void;
  afterShow?: () => void;
  style?: CSSProperties;
  isOpen?: boolean;
}

export function MenuDropDown({
  menu,
  id,
  offset = 0,
  position,
  arrow = false,
  onClick = false,
  afterHide,
  afterShow,
  setActive,
  style,
  isOpen,
}: MenuDropDownProps) {
  const styles: CSSProperties = {
    borderRadius: 8,
    ...style,
  };

  const tooltipRef = useRef<TooltipRefProps>(null);

  const { user: meData } = useUserStore();

  return (
    <Tooltip
      clickable
      id={id}
      ref={tooltipRef}
      place={position}
      offset={offset}
      openOnClick={onClick}
      noArrow={arrow}
      afterHide={() => (afterHide ? afterHide(false) : {})}
      closeEvents={{ click: onClick, mouseleave: onClick ? false : true }}
      isOpen={isOpen}
      className='tooltip shadow-level-4 sm:w-32'
      classNameArrow='tooltip-arrow'
      opacity={1}
      style={styles}
      afterShow={afterShow}
    >
      <div id='dropContentBottomMenu' className='max-h-[70vh] overflow-y-auto'>
        {menu.items.map((item: any, i: number) => (
          <Button
            allowReadOnly
            variant={setActive(item.link)}
            iconVariant='rounded'
            key={i}
            LeftIcon={item.icon}
            iconType={item.iconType}
            target={item.externalLink ? '_blank' : ''}
            onClick={() => {
              tooltipRef.current?.close();
            }}
            asLink
            to={item.link}
            iconSize={item.iconSize}
            full={'menu'}
          >
            {item.label}
            {item.label === 'AprovaLive' && showChipAprovaLive(meData) && (
              <Chip variant='filled' radius='pill' size='sm'>
                NOVO!
              </Chip>
            )}
          </Button>
        ))}
      </div>
    </Tooltip>
  );
}
